import { View } from "react-native";
import { Text, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import { Option } from "../types";

type Props = {
  options: (string | Option)[];
};

export default function VariantOptions({ options }: Props) {
  const { colors } = useTheme();
  const tailwind = useTailwind();

  return (
    <View style={tailwind("flex-row flex-1 flex-wrap")}>
      {options.map((option, index) => (
        <View
          key={index}
          style={[
            tailwind("px-1.5 py-0.5 mb-px mr-1 rounded"),
            { backgroundColor: colors.tertiaryContainer },
          ]}
        >
          <Text
            variant="labelMedium"
            style={{ color: colors.onTertiaryContainer }}
            numberOfLines={1}
          >
            {typeof option === "string" ? option : option.name}
          </Text>
        </View>
      ))}
    </View>
  );
}
